webpackJsonp([12735582197677],{

/***/ 1947:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductConfig","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"defaultNotes","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"dosageConfig","type":{"kind":"OBJECT","name":"ProductDosageConfig","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-product-config-43b2565f8bff7737cf0e.js